import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import PhoneNumberInput from 'src/shared-components/Input/PhoneNumberInput/PhoneNumberInput';
import FootNote from '../../FootNote';
import Label from '../../Label';

interface Props {
  name: string;
  label?: string | ReactElement;
  required?: boolean;
  disabled?: boolean;
}

const FormikPhoneNumberInput: FC<Props> = ({
  name,
  label,
  required,
  disabled
}) => {
  const { setFieldValue, setFieldTouched, values } = useFormikContext();

  const [stateFieldValue, setStateFieldValue] = useState(values[name]);

  useEffect(() => {
    const phoneNumberForSave = stateFieldValue
      ?.replace('(', '')
      ?.replace(')', '');
    setFieldValue(name, phoneNumberForSave);
  }, [stateFieldValue]);

  const handleFieldBlur = () => {
    setFieldTouched(name, true);
  };

  return (
    <Field name={name} required>
      {({ meta }) => {
        const isRegularFieldError = meta.touched && meta.error;

        return (
          <div className="flex flex-col">
            {label && <Label message={label} required={required} />}
            <PhoneNumberInput
              onChangeCallback={setStateFieldValue}
              value={stateFieldValue}
              onBlur={handleFieldBlur}
              isWrong={isRegularFieldError}
              inputWrapperClassName="border-alto/50 h-10"
              required
              disabled={disabled}
              name={name}
            />
            {isRegularFieldError && <FootNote isError message={meta.error} />}
          </div>
        );
      }}
    </Field>
  );
};

export default FormikPhoneNumberInput;
